
const titles = {
    'title':                    'Title',
    'status':                   'Status',
    'system_status':            'System Status',
    'priority':                 'Priority',
    'schedule':                 'Schedule',
    'deadline':                 'Deadline',
    'task-type':                'Type',
    'assigned-to':              'Assigned to',
    'date-created':             'Date created',
    'date-closed':              'Date closed',
    'last-updated':             'Last updated',
    'task-id':                  'ID',
    'parent-task-id':           'Parent Task ID',
    'users':                    'All users',
    'tags':                     'Tags',
    'estimate':                 'Estimate',
    'estimate_minutes':         'Estimate (Minutes)',
    'estimate_hours':           'Estimate (Hours)',
    'progress-bar':             'Progress, %',
    'progress-items':           'Progress, items',
    'progress-auto':            'Progress Tasks',
    'time-reported':            'Time reported',
    'time-reported_minutes':    'Time reported (Minutes)',
    'time-reported_hours':      'Time reported (Hours)',
    'created-by':               'Created by',
    'action-required':          'Action required',
    'start-date':               'Start date',
    'end-date':                 'End date',
    'start-end':                'Start / End',
    'duration-calendar-days':   'Duration',
    'duration-work-days':       'Duration workdays',
    'spent-estimate':           'Spent / Estimate',
    'depends-on':               'Depends On',
    'dependants':               'Dependants',

    'project':                  'Project',
    'project-full-name':        'Project Path',
    'project-status-comments':  'Project status comments',

    'subtasks-counter':         'Subtasks',

    'comments':                 'Comments',
    'open-all':                 'Open tasks',
    'owner':                    'Project owner',
    'project-manager':          'Project manager',
    'project-color':            'Color',
    'project-health':           'Health',

    'description':              'Description',

    'cost-internal':            'Labor cost',
    'cost-external':            'Service cost',
    'expenses':                 'Expenses',

    'story-points':             'Story points',
    'messages-total':           'Messages',
    'attachments-total':        'Attachments',

    'baseline':                 'Baseline',
};


// label in fields list (settings/popover)
const labels : DictionaryStringString = {
    'title':                    'Title',
    'status':                   'Status',
    'system_status':            'System Status',
    'priority':                 'Priority',
    'schedule':                 'Schedule',
    'deadline':                 'Deadline',
    'task-type':                'Type',
    'assigned-to':              'Assigned to',
    'date-created':             'Date created',
    'date-closed':              'Date closed',
    'last-updated':             'Last updated',
    'task-id':                  'ID',
    'parent-task-id':           'Parent Task ID',
    'users':                    'All users',
    'tags':                     'Tags',
    'estimate':                 'Estimate',
    'estimate_minutes':         'Estimate (Minutes)',
    'estimate_hours':           'Estimate (Hours)',
    'progress-bar':             'Progress, %',
    'progress-items':           'Progress, items',
    'progress-auto':            'Progress Tasks',
    'time-reported':            'Time reported',
    'time-reported_minutes':    'Time reported (Minutes)',
    'time-reported_hours':      'Time reported (Hours)',
    'created-by':               'Created by',
    'action-required':          'Action required',
    'start-date':               'Start date',
    'end-date':                 'End date',
    'start-end':                'Start / End',
    'duration-calendar-days':   'Duration calendar days',
    'duration-work-days':       'Duration work days',
    'spent-estimate':           'Spent / Estimate',
    'depends-on':               'Depends On',
    'dependants':               'Dependants',

    'project':                  'Project',
    'project-full-name':        'Project Path',
    'project-status-comments':  'Project status comments',

    'subtasks-counter':         'Subtasks',

    'comments':                 'Comments',
    'open-all':                 'Open tasks',
    'owner':                    'Project owner',
    'project-manager':          'Project manager',
    'project-color':            'Color',
    'project-health':           'Health',

    'description':              'Description',

    'cost-internal':            'Labor cost',
    'cost-external':            'Service cost',
    'expenses':                 'Expenses',

    'story-points':             'Story points',
    'messages-total':           'Messages',
    'attachments-total':        'Attachments',

    'crm-account':              'CRM Account',
    'crm-contacts':             'CRM Contacts',

    'baseline':                 'Baseline',
};

const groups = {
    MAIN:               'main',
    USERS:              'users',
    TIME:               'time',
    DATES:              'dates',
    ESTIMATE:           'estimate',
    FINANCE:            'finance',
    DEPENDENCIES:       'dependencies',
    CRM:                'crm',
    CUSTOM_FIELDS:      'custom-fields',
}

export const FIELDS = {
// module.exports = {

    'title': {
        title           : titles['title'],
        label           : labels['title'],
        icon            : 'i5-text',
        columnId        : '2',
        description     : '',
        group           : groups.MAIN,
        variableName    : '{TITLE}'
    },
    'status':                   { title: titles['status'],                  label: labels['status'],                    icon: 'i5-statuses',                columnId: '6',    description: '', group: groups.MAIN },
    'system_status':            { title: titles['system_status'],           label: labels['system_status'],             icon: 'i5-statuses',                columnId: '6',    description: '', group: groups.MAIN },
    'priority':                 { title: titles['priority'],                label: labels['priority'],                  icon: 'i5-flag',                    columnId: '3',    description: '', group: groups.MAIN },


    // DATES

    'schedule':                 {
        title       : titles['schedule'],
        label       : labels['schedule'],
        icon        : 'i5-date-schedule',
        columnId    : '4',
        description : '', group: groups.DATES
    },
    'deadline':                 { title: titles['deadline'],                label: labels['deadline'],                  icon: 'i5-deadline',                columnId: '9',    description: '', group: groups.DATES },
    'date-created':             { title: titles['date-created'],            label: labels['date-created'],              icon: 'i5-date-created',            columnId: '16',   description: '', group: groups.DATES },
    'date-closed':              { title: titles['date-closed'],             label: labels['date-closed'],               icon: 'i5-date-closed',             columnId: '41',   description: '', group: groups.DATES },
    'last-updated':             { title: titles['last-updated'],            label: labels['last-updated'],              icon: 'i5-date-updated',            columnId: '20',   description: '', group: groups.DATES },
    'start-date':               { title: titles['start-date'],              label: labels['start-date'],                icon: 'i5-date-start',              columnId: '13',   description: '', group: groups.DATES },
    'end-date':                 { title: titles['end-date'],                label: labels['end-date'],                  icon: 'i5-date-end',                columnId: '14',   description: '', group: groups.DATES },


    // USERS

    'created-by':               { title: titles['created-by'],              label: labels['created-by'],                icon: 'i5-user-created',            columnId: '11',   description: '', group: groups.USERS },
    'action-required':          { title: titles['action-required'],         label: labels['action-required'],           icon: 'i5-user-action-required',    columnId: '12',   description: '', group: groups.USERS },
    'assigned-to':              { title: titles['assigned-to'],             label: labels['assigned-to'],               icon: 'i5-user-assigned',           columnId: '18',   description: '', group: groups.USERS },


    'task-type':                { title: titles['task-type'],               label: labels['task-type'],                 icon: 'i5-task-types',              columnId: '8',    description: '', group: groups.MAIN },

    'task-id':                  { title: titles['task-id'],                 label: labels['task-id'],                   icon: 'i5-id',                      columnId: '7',    description: '', group: groups.MAIN },
    'parent-task-id':           { title: titles['parent-task-id'],          label: labels['parent-task-id'],            icon: 'i5-id',                      columnId: '',     description: '', group: groups.MAIN },
    'users':                    { title: titles['users'],                   label: labels['users'],                     icon: 'i5-users',                   columnId: '5',    description: '', group: groups.USERS },
    'tags':                     { title: titles['tags'],                    label: labels['tags'],                      icon: 'i5-tag',                     columnId: '17',   description: '', group: groups.MAIN },
    'progress-bar':             { title: titles['progress-bar'],            label: labels['progress-bar'],              icon: 'i5-progress',                columnId: '21',   description: '', group: groups.TIME },
    'progress-items':           { title: titles['progress-items'],          label: labels['progress-items'],            icon: 'i5-progress',                columnId: '33',   description: '', group: groups.TIME },
    'progress-auto':            { title: titles['progress-auto'],           label: labels['progress-auto'],             icon: 'i5-progress',                columnId: '37',   description: '', group: groups.TIME },
    'time-reported':            { title: titles['time-reported'],           label: labels['time-reported'],             icon: 'i5-my-time',                 columnId: '19',   description: '', group: groups.TIME },
    'time-reported_minutes':    { title: titles['time-reported_minutes'],   label: labels['time-reported_minutes'],     icon: 'i5-my-time',                 columnId: '',     description: '', group: groups.TIME },
    'time-reported_hours':      { title: titles['time-reported_hours'],     label: labels['time-reported_hours'],       icon: 'i5-my-time',                 columnId: '',     description: '', group: groups.TIME },


    'start-end':                { title: titles['start-end'],               label: labels['start-end'],                 icon: 'i5-calendar',                columnId: '27',   description: '', group: groups.DATES },
    'custom-field':             {
        title: '', // titles['custom-field'],
        label: '', // labels['custom-field'], net takih
        icon: '',
        columnId: '',
        description: '',
        group: null
    },
    'project': {
        title: titles['project'],                 label: labels['project'],                   icon: 'i5-project',                           columnId: '29',   description: '', group: groups.MAIN,
        variableName    : '{PROJECT}'
    },

    'project-full-name':        {
        title           : titles['project-full-name'],
        label           : labels['project-full-name'],
        icon            : 'i5-project',
        columnId        : '',
        description     : '',
        group           : null,
        // group           : groups.MAIN,
        variableName    : '{FULL_PATH}'
    },
    'project-status-comments':  {
        title: titles['project-status-comments'],
        label: labels['project-status-comments'],
        icon: '',
        columnId: '',
        description: '',
        group: null
    },

    'subtasks-counter':         { title: titles['subtasks-counter'],        label: labels['subtasks-counter'],          icon: '',                           columnId: '30',   description: '', group: groups.MAIN },
    'comments':                 { title: titles['comments'],                label: labels['comments'],                  icon: '',                           columnId: '22',   description: '', group: groups.MAIN },
    'open-all':                 { title: titles['open-all'],                label: labels['open-all'],                  icon: '',                           columnId: '23',   description: '', group: groups.MAIN },
    'owner':                    {
        title: titles['owner'],
        label: labels['owner'],
        icon: 'i5-user-assigned',
        columnId: '25',
        description: '',
        group: groups.USERS
    },
    'project-manager':          { title: titles['project-manager'],         label: labels['project-manager'],           icon: '',                           columnId: '28',   description: '', group: groups.USERS },
    'project-color':            { title: titles['project-color'],           label: labels['project-color'],             icon: '',                           columnId: '26',   description: '', group: groups.MAIN },
    'project-health':           { title: titles['project-health'],          label: labels['project-health'],            icon: '',                           columnId: '24',   description: '', group: groups.MAIN },
    'duration-calendar-days':   { title: titles['duration-calendar-days'],  label: labels['duration-calendar-days'],    icon: 'i5-age',                           columnId: '31',   description: '', group: groups.DATES },
    'duration-work-days':       { title: titles['duration-work-days'],      label: labels['duration-work-days'],        icon: 'i5-age',                           columnId: '36',   description: '', group: groups.DATES },
    'spent-estimate':           { title: titles['spent-estimate'],          label: labels['spent-estimate'],            icon: 'i5-time-percent',   columnId: '32',   description: '', group: groups.TIME },
    'depends-on':               { title: titles['depends-on'],              label: labels['depends-on'],                icon: 'i5-depends-on',              columnId: '34',   description: '', group: groups.MAIN },
    'dependants':               { title: titles['dependants'],              label: labels['dependants'],                icon: 'i5-dependent',               columnId: '35',   description: '', group: groups.MAIN },

    'description':              { title: titles['description'],             label: labels['description'],               icon: '',                           columnId: '',     description: '', group: groups.MAIN },
    'messages-total':           {
        title: titles['messages-total'],
        label: labels['messages-total'],
        icon: 'i5-chat',    // 'i5-id'
        columnId: '43',
        description: '',
        group: groups.MAIN
    },
    'attachments-total':        {
        title: titles['attachments-total'],       label: labels['attachments-total'],
        icon: 'i5-attachment', // i5-id
        columnId: '44',   description: '', group: groups.MAIN
    },

    'cost-internal':            {
        title: titles['cost-internal'],
        label: labels['cost-internal'],
        icon: 'i5-money',
        columnId: '38',
        description: '',
        group: groups.FINANCE
    },
    'cost-external':            {
        title: titles['cost-external'],
        label: labels['cost-external'],
        icon: 'i5-money',
        columnId: '39',
        description: '', group: groups.FINANCE
    },
    'expenses':                 {
        title: titles['expenses'],
        label: labels['expenses'],
        icon: 'i5-expenses-light',
        columnId: '40',
        description: '',
        group: groups.FINANCE
    },

    'story-points':             { title: titles['story-points'],            label: labels['story-points'],              icon: 'i5-story-points',            columnId: '42',   description: '', group: groups.ESTIMATE },
    'estimate':                 { title: titles['estimate'],                label: labels['estimate'],                  icon: 'i5-time-estimate',           columnId: '10',   description: '', group: groups.ESTIMATE },
    'estimate_minutes':         { title: titles['estimate_minutes'],        label: labels['estimate_minutes'],          icon: 'i5-time-estimate',           columnId: '',     description: '', group: groups.ESTIMATE },
    'estimate_hours':           { title: titles['estimate_hours'],          label: labels['estimate_hours'],            icon: 'i5-time-estimate',           columnId: '',     description: '', group: groups.ESTIMATE },

    'crm-contact': {
        title: 'CRM Contact',
        label: 'CRM Contact',
        icon: 'i5-crm-contact',
        columnId: '45',
        description: '',
        group: groups.CRM
    },
    'crm-contacts': {
        title: 'CRM Contacts',
        label: 'CRM Contacts',
        icon: 'i5-crm-contact',
        columnId: '47',
        description: '',
        group: groups.CRM
    },
    'crm-account': {
        title: 'CRM Account',
        label: 'CRM Account',
        icon: 'i5-crm-account',
        columnId: '46',
        description: '',
        group: groups.CRM
    },

    'todo-list': {
        title       : 'Todo list',
        label       : 'Todo list',
        icon        : 'i5-todo',
        columnId    : '48',
        description : '',
        group       : groups.MAIN
    },

    'cover': {
        title       : 'Cover image',
        label       : 'Cover image',
        icon        : 'i5-cover',
        columnId    : '50',
        description : '',
        group       : groups.MAIN
    },

    //not actual field
    'check-box':                {
        title: '', // titles['check-box'],
        label: '', // labels['check-box'],
        icon: '',
        columnId: '1',
        description: '',
        group: null
    },

    'baseline':                 { title: titles['baseline'],                label: labels['baseline'],                  icon: '',                       columnId: '49',   description: '', group: groups.MAIN },

    titles: titles,
    labels: labels,

    type: {
        TITLE:                  'title',
        PRIORITY:               'priority',
        SCHEDULE:               'schedule',
        DEADLINE:               'deadline',
        TASK_TYPE:              'task-type',
        DATE_CREATED:           'date-created',
        DATE_CLOSED:            'date-closed',
        LAST_UPDATED:           'last-updated',

        COVER                   : 'cover',

        // status fields
        STATUS:                 'status',
        SYSTEM_STATUS:          'system_status',

        //
        TASK_ID:                'task-id',
        PARENT_TASK_ID:         'parent-task-id',
        USERS:                  'users',
        TAGS:                   'tags',
        ESTIMATE:               'estimate',
        ESTIMATE_MINUTES:       'estimate_minutes',
        ESTIMATE_HOURS:         'estimate_hours',
        PROGRESS_BAR:           'progress-bar',         // manual progress ?
        PROGRESS_ITEMS:         'progress-items',       // based on subitem (children)

        // Ok... pohoze chto eto Field kot. schitaet progress v % based on number of tasks (!)
        // progressTasks ... po hodu eto tol'ko dlya proektov nado ???
        PROGRESS_PROJECT_TASKS:          'progress-auto',

        TIME_REPORTED:          'time-reported',
        TIME_REPORTED_MINUTES:  'time-reported_minutes',
        TIME_REPORTED_HOURS:    'time-reported_hours',
        CREATED_BY:             'created-by',
        ACTION_REQUIRED:        'action-required',
        ASSIGNED_TO:            'assigned-to',

        START_DATE:             'start-date',
        END_DATE:               'end-date',
        START_END_DATE:         'start-end',
        //
        CUSTOM_FIELD:           'custom-field',

        PROJECT:                'project',
        PROJECT_TYPE:           'project-type',
        PROJECT_FULL_NAME:      'project-full-name',
        SUBTASKS_COUNTER:       'subtasks-counter',
        DURATION_CALENDAR_DAYS: 'duration-calendar-days',
        DURATION_WORK_DAYS:     'duration-work-days',
        SPENT_ESTIMATE:         'spent-estimate',
        DEPENDS_ON:             'depends-on',
        DEPENDANTS:             'dependants',
        STORY_POINTS:           'story-points',
        MESSAGES_TOTAL:         'messages-total',   // total number of meesages in a task
        ATTACHMENTS_TOTAL:      'attachments-total',

        // FINANCE SECTION
        COST_INTERNAL:          'cost-internal',    // time reports * rate
        COST_EXTERNAL:          'cost-external',    // time reports * rate
        COST_EXPENSES:          'expenses',

        //projects only
        COMMENTS:               'comments',
        OPEN_ALL:               'open-all',
        OWNER:                  'owner',
        PROJECT_MANAGER:        'project-manager',
        PROJECT_COLOR:          'project-color',
        PROJECT_HEALTH:         'project-health',
        PROJECT_STATUS_COMMENTS:'project-status-comments',

        DESCRIPTION:            'description',      // used with task in import at least and export

        //gantt only
        BASELINE:               'baseline',

        //not actual field
        CHECK_BOX:              'check-box',



        // FIELDS2 MOVED TO  src/core/model2/project/project-fields.js
        // pravil'no uzat' FIELDS.STRING
        // tut chto bi ne lomalos' prosto (!)
        // SUDA NE DOBAVLYAT BOLSHE !!!!

        // Field 2.0
        STRING:                 'string',
        TEXT:                   'textarea',
        DROPDOWN:               'dropdown',
        MULTISELECT:            'multiselect',
        COLOR:                  'color',
        USER:                   'user',
        PHONE:                  'phone',
        EMAIL:                  'email',
        URL:                    'url',
        CHECKBOX:               'checkbox',
        NUMBER:                 'number',
        CURRENCY:               'currency',
        PERCENTAGE:             'percentage',
        DATE:                   'date',
        RATING:                 'rating',
        RAG:                    'rag',

        // More System Fields 2.0
        CRM_CONTACT:            'crm-contact',
        CRM_CONTACTS:           'crm-contacts',
        CRM_ACCOUNT:            'crm-account',
        CRM_CONTACT_TYPE:       'crm-contact-type',
        CRM_CONTACTS_TOTAL:     'crm-contacts-total',
        // PROJECT_STATUS:         'project-status'

        // pseudo-field for board
        TODO_LIST           : 'todo-list',
    },

    fieldNameByColumnId: {
        '2':    'title',
        '6':    'status',
        '3':    'priority',
        '4':    'schedule',
        '9':    'deadline' ,
        '8':    'task-type',
        '16':   'date-created',
        '20':   'last-updated',
        '7':    'task-id',
        '5':    'users',
        '17':   'tags',
        '10':   'estimate',
        '21':   'progress-bar',
        '19':   'time-reported',
        '11':   'created-by',
        '12':   'action-required',
        '18':   'assigned-to',
        '13':   'start-date',
        '14':   'end-date',
        '27':   'start-end',
        '22':   'comments',
        '23':   'open-all',
        '25':   'owner',
        '28':   'project-manager',
        '26':   'project-color',
        '24':   'project-health',

        '29':   'project',
        '30':   'subtasks-counter',
        '31':   'duration-calendar-days',
        '36':   'duration-work-days',

        '32':   'spent-estimate',
        '33':   'progress-items',
        '34':   'depends-on',
        '35':   'dependants',
        '37':   'progress-auto',

        '38':   'cost-internal',
        '39':   'cost-external',
        '40':   'expenses',
        '41':   'date-closed',

        '42':   'story-points',
        '43':   'messages-total',
        '44':   'attachments-total',

        '45':   'crm-contact',  // one specific contacts
        '46':   'crm-account',
        '47':   'crm-contacts', // many contacts i.e. for a task in table view

        '48':   'todo-list',

        '49':   'baseline',
        '50':   'cover',


        //not actual field
        '1':    'check-box',
        '0':    'add-cell',
        // 'custom-field'                   ''
        // 'project'                        ''
        // 'subtasks-counter'        ''
    },

    typeTitle: labels,

    groups: groups,

    groupTitle: {
        "main":             "General",
        "users":            "Users",
        "time":             "Time & Progress",
        "dates":            "Dates",
        "finance":          "Finance",
        "dependencies":     "Dependencies",
        'estimate':         "Estimate",
        'crm':              "CRM",
        "custom-fields":    "Custom fields"
    },

    valueType: {
        STRING:     'string',
        BOOLEAN:    'boolean',
        FLOAT:      'float',
        JSON:       'json',
    }
};
